<template>
  <div class="main-content-container position-relative mb-5">
    <div class="top-content-container position-relative">
      <b-breadcrumb class="pb-2">
        <b-breadcrumb-item>
          <span class="breadcrumb--light text-uppercase font-family-medium">
            Resources
          </span>
        </b-breadcrumb-item>
      </b-breadcrumb>
      <h1 class="font-lg font-family-medium primary-dark content-title">
        Wiki Public Support
      </h1>
      <div class="d-flex flex-row align-items-end justify-content-between">
        <div class="top-sub-div px-4 pt-3 py-1">
          <h6 class="font-sm secondary--text">
            Welcome to Public Support's Resource page where you can find useful links & resources,
            EA checklists and explore our Public Support Academy.
          </h6>
        </div>
      </div>
    </div>
    <grid
      :draggable="isAdmin()"
      :sortable="true"
      :items="groups"
      :height="100"
      :width="100"
      :cellWidth="groupWidth"
      :cellHeight="320"
      refs="groupsContainer"
      class="groups-container"
      @dragend="onGroupDrop($event)"
    >
      <slot
        header-tag="header"
        footer-tag="footer"
        slot="cell"
        slot-scope="groupProps"
      >
        <div class="group-card-wrapper card group-card">
          <div class="card-header">
            <div class="d-flex group-title-wrapper">
              <h4
                :contenteditable="isAdmin()"
                @keypress.enter.prevent="
                  onEditGroupTitle(groupProps.index, $event)
                "
                class="editable-text mb-0 quill-editor font-lg primary--text font-family-medium"
              >
                {{ groupProps.item && groupProps.item.title }}
              </h4>
              <b-icon
                v-if="isAdmin()"
                icon="trash"
                font-scale="1.6"
                @click.stop="
                  onPressDeleteGroup(groupProps.item && groupProps.item.id)
                "
                @mousedown.stop
                class="cursor-pointer"
              ></b-icon>
            </div>
            <div
              v-if="groupError.index === groupProps.index"
              class="groupTitleError error-msg"
            >
              {{ groupError.title }}
            </div>
          </div>
          <div class="card-body">
            <draggable
              :disabled="!isAdmin()"
              v-if="
                groupProps.item &&
                  groupProps.item.links &&
                  groupProps.item.links.length
              "
              v-model="groupProps.item.links"
              group="people"
              @start="drag = true"
              @mousedown.stop
              :id="groupProps.index"
              @end="onLinkDrop($event, groupProps.index)"
            >
              <div
                v-for="(link, index) in groupProps.item.links"
                :key="index"
                @mousedown.stop
              >
                <b-list-group-item
                  class="group-link-wrapper group-link mb-2 d-flex"
                  @click.stop="onLinkClick(link)"
                >
                  <span
                    class="mb-0 cursor-pointer primary--text font-family-regular"
                    @mousedown.stop
                  >
                    <b-img
                      src="@/assets/icons/hr_logo_icon.png"
                      v-if="link.isInternal"
                      class="ml-2 mr-1 mb-1 internal-link-logo"
                    ></b-img>
                    <b-icon
                      v-else
                      icon="box-arrow-up-right"
                      font-scale="1.1"
                      class="ml-2 mr-1"
                    ></b-icon>
                    {{ link.title }}
                  </span>
                  <div class="link-icons-wrapper d-flex" v-if="isAdmin()">
                    <b-icon
                      icon="pencil-square"
                      font-scale="1.4"
                      @click.stop="onPressEditLink(link, groupProps.index)"
                      @mousedown.stop
                      class="ml-2"
                    ></b-icon>
                    <b-icon
                      icon="x-square"
                      font-scale="1.4"
                      @click.stop="onPressDeleteLink(link.id)"
                      @mousedown.stop
                      class="ml-2"
                    ></b-icon>
                  </div>
                </b-list-group-item>
              </div>
            </draggable>
            <b-list-group
              v-if="
                groupProps.item &&
                  groupProps.item.links &&
                  groupProps.item.links.length
              "
            >
            </b-list-group>
            <p class="no-link-text" v-else>No Links are added here</p>
          </div>
          <div v-if="isAdmin()" bottom class="card-footer">
            <b-link @click="onPressAddLink(groupProps.index)" @mousedown.stop
              ><h5
                class="mb-0 cursor-pointer primary--text font-family-regular text-underline"
              >
                + Add New Link
              </h5></b-link
            >
          </div>
        </div>
      </slot>
    </grid>
    <!-- Group Creation Form Modal -->
    <div>
      <b-modal
        v-model="showGroupCreateModal"
        ref="modal"
        size="md"
        hide-footer
        hide-header
        centered
      >
        <b-button
          @click="onHideGroupCreateModal"
          class="d-flex position-absolute close-btn"
        >
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
        <h2 class="font-family-medium primary--text mt-2 pl-4 pt-4">
          Add Group
        </h2>
        <b-form class="group-form pl-4" @submit.stop.prevent="onSubmitGroup">
          <b-form-group id="group-title" label="Title *">
            <b-form-input
              id="input-group-title"
              name="input-group-title"
              v-model="currentGroup.title"
              placeholder="Enter Title"
              @keyup="onAddGroupTitleKeyup"
            ></b-form-input>
            <div
              v-if="!currentGroup.title"
              class="addGroupTitleError error-msg"
            >
              Title can not be empty!
            </div>
            <div
              v-else-if="groupError && groupError.title"
              class="addGroupTitleError error-msg"
            >
              {{ groupError.title }}
            </div>
          </b-form-group>
          <b-form-group>
            <b-button
              type="submit"
              class="btn-danger btn-pill px-5 py-3 mt-4 mb-2"
              >Submit
            </b-button>
          </b-form-group>
        </b-form>
      </b-modal>
    </div>
    <!-- Link Creation Form Modal -->
    <div>
      <b-modal
        v-model="showLinkFormModal"
        ref="modal"
        size="lg"
        hide-footer
        hide-header
        centered
      >
        <b-button
          @click="onHideLinkEditModal"
          class="d-flex position-absolute close-btn"
        >
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
        <h2 class="font-family-medium primary--text mt-2 pl-5 pt-4">
          Add / Edit Link
        </h2>
        <b-form class="link-form" @submit.stop.prevent="onSubmitLink">
          <b-form-group id="link-title" label="Title *">
            <b-form-input
              id="input-link-title"
              name="input-link-title"
              v-model="currentLink.title"
              placeholder="Enter Title"
              @keyup="onLinkTitleKeyup"
            ></b-form-input>
            <div v-if="!currentLink.title" class="linkTitleError error-msg">
              Title can not be empty!
            </div>
            <div
              v-else-if="linkError && linkError.title"
              class="linkTitleError error-msg"
            >
              {{ linkError.title[0] }}
            </div>
          </b-form-group>
          <b-form-group id="link-url" label="Url">
            <b-form-input
              id="input-link-url"
              v-model="currentLink.link"
              placeholder="Enter Link Url"
              @keyup="onLinkUrlKeyup"
              required
            ></b-form-input>
            <div v-if="!currentLink.link" class="linkUrlError error-msg">
              URL can not be empty!. And it should be start with http:// or
              https://
            </div>
            <div
              v-else-if="linkError && linkError.link"
              class="linkTitleError error-msg"
            >
              {{ linkError.link[0] }}
            </div>
            <div
              v-else-if="linkError && linkError.nonFieldErrors"
              class="linkTitleError error-msg"
            >
              {{ linkError.nonFieldErrors[0] }}
            </div>
          </b-form-group>
          <b-form-group id="link-desc" label="Description">
            <b-form-input
              id="input-link-desc"
              v-model="currentLink.description"
              type="text"
              placeholder="Enter Link Description"
            ></b-form-input>
          </b-form-group>
          <b-form-group id="link-scope" label="Internal Link">
            <b-form-checkbox
              id="input-link-scope"
              v-model="currentLink.isInternal"
              name="input-link-scope"
              value="true"
              unchecked-value="false"
              class="font-lg primary--text font-family-medium"
              size="lg"
              ><span class="primary--text font-family-regular"
                >Internal Link</span
              ></b-form-checkbox
            >
            <b-button
              type="submit"
              class="btn-danger btn-pill px-5 py-3 mt-4 mb-2"
              >Submit
            </b-button>
          </b-form-group>
        </b-form>
      </b-modal>
    </div>
    <!-- Group Delete Confirmation Modal -->
    <div>
      <b-modal
        v-model="showGroupDeleteModal"
        ref="modal"
        centered
        hide-footer
        hide-header
      >
        <b-container fluid class="modal-delete-container">
          <b-button
            @click="onHideGroupDeleteModal"
            class="d-flex position-absolute close-btn"
          >
            <img
              class="close-icon"
              src="@/assets/icons/close_sidebar.svg"
              alt
            />
          </b-button>
          <b-row align-v="center">
            <b-col md="12" class="flex-row d-flex p-0">
              <div
                class="d-flex flex-column justify-content-center position-relative m-0"
              >
                <h2
                  class="font-family-medium primary--text mt-2 delete-popup-title"
                >
                  Are you sure?
                </h2>
                <p
                  class="font-family-regular secondary--text mt-1 font-size-md"
                >
                  Do you want to delete this group?
                </p>
              </div>
            </b-col>
            <b-button
              class="btn-danger btn-pill px-5 py-3 mt-4 mb-2"
              @click.prevent="deleteGroup"
              >Delete
            </b-button>
          </b-row>
        </b-container>
      </b-modal>
    </div>
    <!-- Group Link Delete Confirmation Modal -->
    <div>
      <b-modal
        v-model="showGroupLinkDeleteModal"
        ref="modal"
        centered
        hide-footer
        hide-header
      >
        <b-container fluid class="modal-delete-container">
          <b-button
            @click="onHideGroupLinkDeleteModal"
            class="d-flex position-absolute close-btn"
          >
            <img
              class="close-icon"
              src="@/assets/icons/close_sidebar.svg"
              alt
            />
          </b-button>
          <b-row align-v="center">
            <b-col md="12" class="flex-row d-flex p-0">
              <div
                class="d-flex flex-column justify-content-center position-relative m-0"
              >
                <h2
                  class="font-family-medium primary--text mt-2 delete-popup-title"
                >
                  Are you sure?
                </h2>
                <p
                  class="font-family-regular secondary--text mt-1 font-size-md"
                >
                  Do you want to delete this link?
                </p>
              </div>
            </b-col>
            <b-button
              class="btn-danger btn-pill px-5 py-3 mt-4 mb-2"
              @click.prevent="deleteGroupLink"
              >Delete
            </b-button>
          </b-row>
        </b-container>
      </b-modal>
    </div>
    <b-avatar
      button
      @click="onAddGroupClicked"
      size="4.8rem"
      class="floating-action-btn mb-5 position-fixed cursor-pointer"
      v-if="isAdmin()"
    >
      <img src="@/assets/icons/floating_plus.svg" alt="" />
    </b-avatar>
    <!-- Indicator Toasts -->
    <SaveIndicator ref="saveIndicator" />
  </div>
</template>

<script>
import {
  deleteResourceGroup,
  deleteResourceGroupLink,
  getResourceGroups,
  postResourceGroup,
  postResourceGroupLink,
  reorderGroup,
  reorderGroupLinks,
  updateResourceGroup,
  updateResourceGroupLink
} from "@/apis/common";
import { mapState } from "vuex";
import SaveIndicator from "@/components/indicators/SaveIndicator.vue";
import _ from "lodash";
import { isAdmin } from "@/utils/utils";
import draggable from "vuedraggable";

export default {
  name: "Resources",
  components: {
    SaveIndicator,
    draggable
  },
  computed: {
    ...mapState("authModule", ["role"])
  },
  data() {
    return {
      groups: [],
      groupPositionOffset: 1000,
      groupWidth: (window.innerWidth * 80) / 100 / 3,
      items: ["a", "b", "c", "d", "e", "f", "g", "h"],
      groupProps: {
        items: {
          default: () => []
        },
        gridWidth: 300,
        cellWidth: {
          type: Number,
          default: 300
        },
        cellHeight: {
          type: Number,
          default: 200
        },
        draggable: {
          type: Boolean,
          default: false
        },
        dragDelay: {
          type: Number,
          default: 0
        },
        sortable: {
          type: Boolean,
          default: false
        },
        center: {
          type: Boolean,
          default: false
        }
      },
      disableAddCard: false,
      newGroupTitle: "",
      showGroupCreateModal: false,
      showLinkFormModal: false,
      showGroupDeleteModal: false,
      showGroupLinkDeleteModal: false,
      groupIdToDelete: null,
      linkIdToDelete: null,
      linkIdToEdit: null,
      currentLink: {
        id: "",
        title: "",
        description: "",
        link: "",
        isInternal: false,
        group: "",
        groupIndex: 0
      },
      currentGroup: {
        id: "",
        title: ""
      },
      groupError: {
        title: null,
        index: null
      },
      linkError: null
    };
  },
  created() {
    this.getGroups();
    this.trackView();
  },
  mounted() {
    this.showSaveIndicator = this.$refs.saveIndicator.showSaveIndicator;
    this.showSaveIndicatorSaved = this.$refs.saveIndicator.showSaveIndicatorSaved;
    this.showSaveIndicatorError = this.$refs.saveIndicator.showSaveIndicatorError;
    this.clearSaveIndicators = this.$refs.saveIndicator.clearSaveIndicators;
  },
  methods: {
    isAdmin,
    trackView() {
      this.$gtag.event("Resources - View", {
        event_category: "feature"
      });
    },
    trackLinkClick(link_title) {
      this.$gtag.event(`Resources - ${link_title} Click`, {
        event_category: "feature"
      });
    },
    checkRoleAndNavigate() {
      if (this.role === "admin") {
        this.$router.push({ name: "CreatePAAccount" });
      }
    },
    navigate() {
      this.$router.push({ name: "AddCustomer" });
    },
    async getGroups() {
      try {
        let res = await getResourceGroups();
        let groups = [];
        this.groupPositionOffset = res.data?.offset;
        groups = res.data?.results.map(group => {
          return this.sortLinksByPosition(group);
        });
        this.groups = this.sortGroupsByPosition(groups);
      } catch (err) {
        console.log(err);
      }
    },
    sortGroupsByPosition(groups) {
      let sortedGroups = [];
      groups.forEach(group => {
        sortedGroups[group.position] = group;
      });
      sortedGroups = sortedGroups.filter(value => value !== undefined);
      return sortedGroups;
    },
    sortLinksByPosition(group) {
      let sortedListGroup = _.cloneDeep(group);
      sortedListGroup.links = [];
      group?.links.forEach(link => {
        sortedListGroup.links[link.position] = link;
      });
      sortedListGroup.links = sortedListGroup.links.filter(
        value => value !== undefined
      );
      return sortedListGroup;
    },
    onAddGroupClicked() {
      this.onHideGroupCreateModal();
      this.showGroupCreateModal = true;
    },
    onEditGroupTitle(groupIndex, event) {
      this.groupError = {
        title: null,
        index: null
      };
      this.updateGroup(groupIndex, event);
    },
    onSubmitGroup() {
      if (!this.currentGroup.title) {
        return;
      }
      this.createNewGroup();
    },
    async createNewGroup() {
      let data = {
        title: this.currentGroup.title,
        position:
          (this.groups?.length
            ? this.groups[this.groups.length - 1]?.position
            : 0) + this.groupPositionOffset
      };
      this.showSaveIndicator();
      try {
        let res = await postResourceGroup(data);
        this.groups.push({
          title: res.data.title,
          position: res.data.position,
          id: res.data.id
        });
        this.getGroups();
        this.showSaveIndicatorSaved();
        this.onHideGroupCreateModal();
      } catch (err) {
        if (err.response?.data?.title) {
          this.groupError = {
            title: err.response.data.title[0]
          };
          this.clearSaveIndicators();
        } else {
          this.showSaveIndicatorError();
        }
      }
    },
    onHideGroupCreateModal() {
      this.currentGroup = {
        id: "",
        title: ""
      };
      this.groupError = {
        title: null,
        index: null
      };
      this.showGroupCreateModal = false;
    },
    async updateGroup(groupIndex, event) {
      let data = {
        title: event.currentTarget.innerText,
        position: this.groups[groupIndex].position
      };
      this.showSaveIndicator();
      try {
        let res = await updateResourceGroup(this.groups[groupIndex].id, data);
        this.groups[groupIndex] = {
          title: res.data.title,
          position: res.data.position,
          id: res.data.id
        };
        this.showSaveIndicatorSaved();
      } catch (err) {
        if (err.response?.data?.title) {
          this.groupError = {
            title: err.response.data.title[0],
            index: groupIndex
          };
          this.clearSaveIndicators();
        } else {
          this.showSaveIndicatorError();
        }
      }
    },
    onGroupDrop(event) {
      let previousIndex = event.index;
      let newIndex = event.sort;
      if (previousIndex === newIndex) {
        return;
      }
      let newPosition = this.getGroupNewPosition(previousIndex, newIndex);
      let groupId = this.groups[event.index].id;
      this.updateGroupsPosition(groupId, newPosition);
    },
    getGroupNewPosition(previousIndex, newIndex) {
      let newPosition = null;
      if (previousIndex > newIndex) {
        if (newIndex === 0) {
          newPosition = Math.floor(this.groups[newIndex].position / 2);
        } else {
          newPosition = Math.floor(
            (this.groups[newIndex - 1].position +
              this.groups[newIndex].position) /
              2
          );
        }
      } else if (previousIndex < newIndex) {
        if (newIndex === this.groups.length - 1) {
          newPosition =
            this.groups[newIndex].position + this.groupPositionOffset;
        } else {
          newPosition = Math.floor(
            (this.groups[newIndex].position +
              this.groups[newIndex + 1].position) /
              2
          );
        }
      }
      return newPosition;
    },
    async updateGroupsPosition(groupId, newPosition) {
      const data = [
        {
          id: groupId,
          position: newPosition
        }
      ];
      try {
        await reorderGroup(data);
        this.getGroups();
        this.showSaveIndicatorSaved();
      } catch {
        this.showSaveIndicatorError();
      }
    },
    onPressDeleteGroup(groupId) {
      this.showGroupDeleteModal = true;
      this.groupIdToDelete = groupId;
    },
    onHideGroupDeleteModal() {
      this.groupIdToDelete = null;
      this.showGroupDeleteModal = false;
    },
    onAddGroupTitleKeyup() {
      this.groupError && (this.groupError.title = null);
    },
    async deleteGroup() {
      try {
        if (this.groupIdToDelete) {
          this.showSaveIndicator();
          let res = await deleteResourceGroup(this.groupIdToDelete);
          if (res.status === 204) {
            this.showSaveIndicatorSaved();
          }
        }
      } catch {
        this.showSaveIndicatorError();
      } finally {
        this.getGroups();
        this.showGroupDeleteModal = false;
      }
    },
    beforeGroupDragStart() {
      return true;
    },
    async onSubmitLink() {
      if (!this.currentLink.title || !this.currentLink.link) {
        return;
      }
      let thisGroup = this.groups[this.currentLink.groupIndex];
      let data = {
        title: this.currentLink.title,
        description: this.currentLink.description,
        link: this.currentLink.link,
        position:
          this.currentLink.position >= 0
            ? this.currentLink.position
            : (thisGroup?.links[thisGroup?.links.length - 1]?.position ?? 0) +
              1,
        is_internal: this.currentLink.isInternal,
        group: thisGroup.id
      };
      this.showSaveIndicator();
      if (this.currentLink.id) {
        this.updateLink(this.currentLink.id, data);
      } else {
        this.createNewLink(data);
      }
    },
    async createNewLink(data) {
      try {
        await postResourceGroupLink(data);
        this.getGroups();
        this.showSaveIndicatorSaved();
        this.showLinkFormModal = false;
        this.onHideLinkEditModal();
      } catch (err) {
        if (err.response?.data) {
          this.linkError = err.response.data;
          this.clearSaveIndicators();
        } else {
          this.showSaveIndicatorError();
        }
      }
    },
    async updateLink(linkId, data) {
      try {
        await updateResourceGroupLink(linkId, data);
        this.getGroups();
        this.showSaveIndicatorSaved();
        this.showLinkFormModal = false;
        this.onHideLinkEditModal();
      } catch (err) {
        if (err.response?.data) {
          this.linkError = err.response.data;
          this.clearSaveIndicators();
        } else {
          this.showSaveIndicatorError();
        }
      }
    },
    onPressAddLink(groupIndex) {
      this.onHideLinkEditModal();
      this.showLinkFormModal = true;
      this.currentLink.groupIndex = groupIndex;
    },
    onPressEditLink(link, groupIndex) {
      this.showLinkFormModal = true;
      this.linkIdToEdit = link.id;
      const linkDeepCopy = _.cloneDeep(link);
      this.currentLink = linkDeepCopy;
      this.currentLink.groupIndex = groupIndex;
    },
    onPressDeleteLink(linkId) {
      this.showGroupLinkDeleteModal = true;
      this.linkIdToDelete = linkId;
    },
    onHideGroupLinkDeleteModal() {
      this.linkIdToDelete = null;
      this.linkIdToEdit = null;
      this.showGroupLinkDeleteModal = false;
    },
    onHideLinkEditModal() {
      this.currentLink = {
        id: "",
        title: "",
        description: "",
        link: "",
        isInternal: false,
        group: "",
        groupIndex: null
      };
      this.linkError = null;
      this.showLinkFormModal = false;
    },
    onLinkClick(linkData) {
      this.trackLinkClick(linkData.title);
      window.open(linkData.link, linkData.isInternal ? "_self" : "_blank");
    },
    onLinkDragLeave(event) {
      event;
      return;
    },
    onLinkDrop(event, groupIndex) {
      if (event.from !== event.to) {
        this.getGroups();
        return;
      } else if (
        (!(event.oldIndex >= 0) && !(event.from.$el.newIndex >= 0)) ||
        event.oldIndex === event.newIndex
      ) {
        return;
      }
      this.updateLinksPosition(groupIndex);
    },
    async updateLinksPosition(groupIndex) {
      const data = {
        group: this.groups[groupIndex].id,
        links: this.groups[groupIndex].links.map((link, index) => ({
          id: link.id,
          position: index
        }))
      };
      try {
        await reorderGroupLinks(data);
        this.getGroups();
        this.showSaveIndicatorSaved();
      } catch {
        this.showSaveIndicatorError();
        this.getGroups();
      } finally {
        this.showLinkFormModal = false;
      }
    },
    async deleteGroupLink() {
      this.showSaveIndicator();
      try {
        let res = await deleteResourceGroupLink(this.linkIdToDelete);
        if (res.status === 204) {
          this.showSaveIndicatorSaved();
        }
      } catch {
        this.showSaveIndicatorError();
      } finally {
        this.getGroups();
        this.showGroupLinkDeleteModal = false;
      }
    },
    onLinkTitleKeyup() {
      this.linkError && (this.linkError.title = null);
    },
    onLinkUrlKeyup() {
      this.linkError && (this.linkError.link = null);
      this.linkError && (this.linkError.nonFieldErrors = null);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/scss/variables/colors.scss";
@import "~@/scss/common/fonts.scss";
.top-sub-div {
  margin: 1rem 0;
  width: 80%;
  border: 1px solid let(--border);
  background: #074f890a 0% 0% no-repeat padding-box;
  border: 1px solid #dcebf4;
  border-radius: 4px;
  opacity: 1;
}
.procedure-container {
  flex-direction: row;
  border: 1px solid #dcebf4;
  border-radius: 4px;
  opacity: 1;
  justify-content: space-between;
}
.procedure-card {
  height: 27.5rem;
  width: 24%;
  padding: 2rem 2rem 1rem 3rem;
}
.container-body {
  margin-bottom: 5rem;
}
.floating-action-btn {
  right: 3rem;
  z-index: 2;
  bottom: 0;
}
.icon-text {
  top: 0.2rem;
}
.icon-text:hover {
  text-decoration: underline;
}
.group-title-wrapper,
.group-link-wrapper {
  justify-content: space-between;
}
.group-title-wrapper {
  h4 {
    width: 75%;
  }
}
.group-link-wrapper {
  cursor: pointer;
  border-radius: 4px;
  border: unset;
  padding: 0.75rem 0;
}
.group-card-wrapper {
  border-radius: 0.25rem;
  width: 100%;
  height: 100%;
  background-color: white;
  border: 1px solid #e0edfb;
  padding: 1.5rem;
  .card-header,
  .card-footer {
    background-color: unset;
    border: none;
  }
  .card-header {
    border-bottom: 1px solid $primary-lighter;
    padding: 0.5rem 0.3rem 1rem 1rem;
  }
  .card-footer {
    border-top: 1px solid $primary-lighter;
    padding: 1.5rem 1rem 0 1rem;
  }
  .card-body {
    padding: 0.5rem;
    max-height: 22rem;
    overflow-y: auto;
  }
  > .card-body::-webkit-scrollbar {
    width: 0.6rem;
  }
  > .card-body::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    background-color: #f6f9fc;
    // width: 5px;
    border-radius: 5px;
  }
  > .card-body::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #cbd6e0;
  }
  .no-link-text {
    padding: 1rem;
  }
  .group-card {
    border: unset;
    padding: 1.5rem 0.5rem;
    height: 100%;
  }
}
.add-new-card-wrapper {
  width: 6rem;
  height: 6rem;
  position: fixed;
  bottom: 1rem;
  right: 1.5rem;
  z-index: 10;
  .card-body {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .add-btn {
    color: $primary;
  }
}
.editable-text:focus {
  border: none;
  outline: none;
  cursor: text;
}
.card-header,
.card-footer {
  background-color: rgba(0, 0, 0, 0.02);
}
.link-form,
.delete-group-modal-controls.buttons-row,
.delete-link-modal-controls.buttons-row {
  button {
    padding: 8px 15px;
  }
  .cancel-button {
    margin-right: 10px;
    background: white;
    color: $primary-dark;
    border: 1px solid $primary-dark;
  }
  .delete-button {
    border: 1px solid transparent;
  }
}
.position-absolute {
  position: absolute !important;
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
.modal-body {
  .container-fluid {
    padding: 1rem 3rem;
  }
}
.link-form {
  padding: 2rem 3rem;
}
.error-msg {
  color: var(--td-btn-primary, #8f00ff);
  font-size: $font-size-xs;
}
.error-msg:first-letter {
  text-transform: capitalize;
}
.internal-link-logo {
  border: 1px solid $primary;
  border-radius: 2px;
  width: 20px;
  height: 20px;
  padding: 0.125rem;
  box-sizing: border-box;
  object-fit: contain;
}
.link-icons-wrapper {
  justify-content: flex-end;
}
</style>
<style lang="scss">
@import "~@/scss/variables/colors.scss";
.groups-container {
  margin-bottom: 8rem;
  margin-left: -1.5rem;
}
.v-grid-item-wrapper {
  border: 1.5rem solid transparent; // hidden border to create a gap between groups which is not possible by margin due to forced animation css of package
  box-sizing: border-box;
}
.v-grid-item-wrapper.v-grid-item-animate {
  transition: none !important;
}
</style>
